<h2 mat-dialog-title> Nueva carpeta</h2>
<mat-dialog-content>

  <form [formGroup]="form">
    <mat-form-field class='formField'>
      <mat-label>Nombre</mat-label>
      <input matInput placeholder="Nombre" formControlName="name" required autofocus>
      <mat-error>El nombre es obligatorio</mat-error>
      <mat-error>Solo puede contener letras y números</mat-error>
    </mat-form-field>
  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Crear</button>
</mat-dialog-actions>
